import React, { useEffect, useState } from "react";
import API from '../Services/PlayPoint'
import APIS from '../Services/MemberShip'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlayPointList from "../Components/PlayPointList";


const PlayPoint = () => {
    const [paymentAmount, setPaymentAmount] = useState("")
    const [playPoint, setPlayPoint] = useState("")
    const [memberShip, setMemberShip] = useState([])
    const [error, setError] = useState({});
    const [selectMembership, setSelectMembership] = useState("")
    useEffect(() => {
        getMemberShipList();

    }, []);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "paymentAmount":
                setPaymentAmount(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            case "selectMembership":
                setSelectMembership(value);
                break;
        
            default:
                break;
        }
    };


    const validateFields = () => {
        const errors = {};
        const priceRegex = /^\d+(\.\d{1,2})?$/;
        if (!paymentAmount || String(paymentAmount).trim() === "") {
            errors.paymentAmount = "Payment amount is required";
        } else if (!priceRegex.test(String(paymentAmount))) {
            errors.paymentAmount = "paymentAmount must be a valid number (e.g., 100 or 100.50)";
        }
        const PlayPoint = /^\d+(\.\d{1,2})?$/;
        if (!playPoint || String(playPoint).trim() === "") {
            errors.playPoint = "SkyCoins is required";
        } else if (!PlayPoint.test(String(playPoint))) {
            errors.playPoint = "SkyCoins must be a valid number (e.g., 100 or 100.50)";
        }
        // if (!selectMembership) {
        //     errors.selectMembership = "Membership is required";
        // }
      
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const addPlayPoints = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                payment_amount: paymentAmount,
                play_point: playPoint,
                membership_id:null
                //membership_id: selectMembership,
                //is_active: true
            };
            const response = await API.addPlayPoints(payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "SkyCoins created successfully!!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "SkyCoins not added. Please try again later.");

            }
        } catch (error) {
            console.error("Error adding designation:", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }

    };


    const getMemberShipList = async () => {
        try {
            const response = await APIS.getMemberShip({ is_active: true });
            setMemberShip(response?.data?.data?.rows);
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch membership data.",
            }));
            handleError(error);
        }
    };


    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    const handleChange = (e) => {
        const value = e.target.value;
        setSelectMembership(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.selectMembership;
            return updatedErrors;
        });
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;

        await addPlayPoints();

    };

    const handleCancel = () => {
        setTimeout(() => window.location.reload());
        setPlayPoint('');
        setPaymentAmount('')
        setSelectMembership('')

    };

    return (
        <div>

            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    
                    <div className="card-body">
                        <h4 className="card-title">SkyCoins </h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">Payment Amount <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtPayment"
                                            placeholder="PaymentAmount"
                                            value={paymentAmount}
                                            onChange={(e) => handleFieldChange(e, "paymentAmount")}

                                        />
                                            {error?.paymentAmount && (
                                                <span className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.paymentAmount}
                                                </span>
                                            )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">SkyCoins <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtPoints"
                                            placeholder="SkyCoins"
                                            value={playPoint}
                                            onChange={(e) => handleFieldChange(e, "playPoint")}
                                        />
                                        {error?.playPoint && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.playPoint}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="dddMamber">Membership <span style={{ color: "red" }}>*</span></label>
                                            <select
                                                className="form-select"
                                                id="ddMamber"
                                                value={selectMembership}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select</option>
                                                {memberShip.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {error?.selectMembership && (
                                                <p className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.selectMembership}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                 
                                </div> */}
                            </div>
                            <div className="mt-3">
                              
                                <button
                                    onClick={handleSubmit}
                                    type="button"
                                    className="btn btn-primary me-3"
                                >
                                    Submit
                                </button>

                                <button onClick={handleCancel} className="btn btn-light">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
            <PlayPointList />
        </div>
    );
};

export default PlayPoint;